
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/designing-data-intensive-applications",
      function () {
        return require("private-next-pages/books/designing-data-intensive-applications.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/designing-data-intensive-applications"])
      });
    }
  